import axios from '../http-common';
import * as actionTypes from '../actions/types';
import CatalogoService from '../services/catalogo';
import { actualizarAtriutoVentanaDialogo } from './ventanaDialogo';
import cartaImgSrc from '../assets/img/PRESTADORES_Mesadetrabajo1.png';
import React from 'react';

export const actualizarAtriutoGrilla = (objeto) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_ATRIBUTOS_GRILLA,
        payload: objeto,
    });
};

export const resetFiltroGrilla = () => (dispatch) => {
    dispatch(actualizarAtriutoGrilla({ filtro: null }));
};

export const setFiltroGrilla = (filtro) => (dispatch) => {
    dispatch({ type: actionTypes.SET_FILTRO_GRILLA, payload: filtro });
};

export const getEstadosPresentaciones = () => (dispatch) => {
    CatalogoService.listadoEstados().then((response) => {
        dispatch({
            type: actionTypes.SET_ESTADOS_FILTRO,
            payload: response.data,
        });
    });
};

const queryString = require('query-string');

const cerrarDialogo = () => (dispatch) => {
    const ventanaConfig = {
        estaVisible: false,
    };

    dispatch(actualizarAtriutoVentanaDialogo(ventanaConfig));
};

export const mostrarAvisoPrestadores = () => (dispatch) => {
    const imagen = [
        <img
            src={cartaImgSrc}
            draggable={false}
            style={{maxWidth: '900px', width: '100%', minWidth: '600px'}}
            key="cartaImgAviso"
        />
    ];

    const ventanaConfig = {
        estaVisible: true,
        titulo: "",
        contenido: imagen,
        clickAceptar: () => dispatch(cerrarDialogo()),
    };

    dispatch(actualizarAtriutoVentanaDialogo(ventanaConfig));
};

export const getPresentaciones = (filtro) => (dispatch) => {
    dispatch(actualizarAtriutoGrilla({ fetching: true }));
    
    axios
        .get('/presentaciones/', {
            params: {
                ...filtro,
                page: (sessionStorage.getItem('filtrosCambiados')==='true')? 0 : filtro.page
            },
            paramsSerializer: (params) => {
                return queryString.stringify(params);
            },
            headers: {
                'Content-type': 'application/json',
            },
        })
        .then((response) => {
            dispatch({
                type: actionTypes.SET_PRESENTACIONES,
                payload: response.data.content,
            });

            const datos = {
                cantidadTotal: response.data.totalElements,
                paginaActual: response.data.pageable.pageNumber,
                filasPorPagina: response.data.pageable.pageSize,
                fetching: false,
            };

            if (Object.keys(filtro).length > 1) {
                datos.filtroActivo = true;
            }

            dispatch(actualizarAtriutoGrilla(datos));
            sessionStorage.setItem('filtrosCambiados', false);
        });
};

export const cambiarPaginaFilasTabla = (filtro) => (dispatch, getState) => {
    sessionStorage.setItem('nroPagTabla', filtro.page);
    dispatch({ type: actionTypes.SET_FILTRO_GRILLA, payload: filtro });
    const filtroActualizado = getState().grillaPrincipalReducer.filtro;
    dispatch(getPresentaciones(filtroActualizado));
};

export const mostrarAviso = () => (dispatch) => {
    axios
        .get('/params-gen/aviso-mant', {
            params: {},
            headers: {
                'Content-type': 'application/json',
            },
        })
        .then((response) => {
            if(response.data.titulo){
                const cont = response.data.msjMant.replaceAll('\\n','\n');
                const titulo = response.data.titulo;
                    
                const ventanaConfig = {
                    estaVisible: true,
                    titulo: titulo,
                    contenido: cont,
                    maxWidth: 'md',
                    whiteSpace: 'break-spaces',
                    clickAceptar: () => dispatch(cerrarAviso()),
                };
            
                dispatch(actualizarAtriutoVentanaDialogo(ventanaConfig));
                
            }
        })   
}

export const cerrarAviso = () => (dispatch) => {
    const ventanaConfig = {
        estaVisible: false,
    };

    sessionStorage.setItem("AvisoMant", "S");

    dispatch(actualizarAtriutoVentanaDialogo(ventanaConfig));
};